<script>
  import { Fruehstuecksworkshop } from "../Api/congress";
  import { operationStore, query } from "@urql/svelte";
  import Item from "./Fruehstuecksworkshop/Item.svelte";
  import Header from "../Component/Header.svelte";
  import CFAText from "../Component/CFAText.svelte";
  import { Loading } from "../../Components/Icons";

  export let congressId;
  const widgetView = "fruehstuecksworkshop";

  let workshopdata = {
    cfaTextsteuerung: 0,
  };

  let showLoading = true;

  const congressFruehstuecksworkshop = operationStore(Fruehstuecksworkshop, { congressId, widgetView });

  query(congressFruehstuecksworkshop);

  congressFruehstuecksworkshop.subscribe((storeObj) => {
    showLoading = storeObj.fetching;
    if (!showLoading && storeObj.data) {
      workshopdata = storeObj.data.fruehstuecksworkshopdata;
    }
  });
</script>

<Header {congressId} {...workshopdata} />

<Loading {showLoading} class="mx-auto" display="block" />

{#if workshopdata?.title}
  <h2 class="my-2.5 text-center">{@html workshopdata.title}</h2>
  <hr class="hr-gradient mb-2.5" />
{/if}

{@html workshopdata?.headdescription || ""}
<CFAText enable={workshopdata?.cfaTextsteuerung == 1} />
{@html workshopdata?.logoblock || ""}

{#each workshopdata?.eventlist || [] as item}
  <Item {item} />
{/each}
